import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTideComponent } from './simple-icons-tide.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTideComponent ],
    exports:      [ SimpleIconsTideComponent ],
    bootstrap:    []
})
export class SimpleIconsTideModule {}
